import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PropertiesService } from "@scaffold/services/properties.service";
import { DataModelService } from "@services/data-model.service";

@Component({
  selector: "app-map-value",
  templateUrl: "./map-value.component.html",
  styleUrls: ["./map-value.component.scss"],
})
export class MapValueComponent implements OnInit {
  @Input() selectedItem;
  @Input() rootItem;
  @Input() item: any;
  @Input() parentView: any;
  @Input() fileSet: boolean;
  @Output() changed = new EventEmitter();

  public options = [];

  public fromValue = "";
  public toValue = "";
  public mapValues = [];

  constructor(
    private dataModelService: DataModelService,
    public properties: PropertiesService
  ) {}

  ngOnInit(): void {
    this.mapValues = this?.selectedItem?.values_to_map||[]
  }

  addMap() {
    this.mapValues.push({
      fromValue: this.fromValue,
      toValue: this.toValue,
    });
    this.selectedItem[this.item.param] = this.mapValues
    this.fromValue = "";
    this.toValue = "";
    this.properties.changeValue();
    this.changed.emit("");
  }

  removeMap(index) {
    this.mapValues.splice(index, 1);
    this.selectedItem[this.item.param] = this.mapValues
    this.properties.changeValue();
    this.changed.emit("");
  }
}
